import { render, staticRenderFns } from "./Consume.vue?vue&type=template&id=4e080bbe&scoped=true"
import script from "./Consume.vue?vue&type=script&lang=ts"
export * from "./Consume.vue?vue&type=script&lang=ts"
import style0 from "./Consume.vue?vue&type=style&index=0&id=4e080bbe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e080bbe",
  null
  
)

export default component.exports